import { FilterChoice } from '../../common/components/SearchHeader/types/FilterChoice';
import { makeSearchUrl } from '../../common/components/SearchHeader/urls/makeSearchUrl';
import { LinkSpec } from '../SearchFooter/preset-links/helpers';

/** Generates a {url, title} pair from some filters (and an optional custom title) */
export const makeLinkSpec = (filters: FilterChoice, customTitle?: string): LinkSpec => ({
  url: makeSearchUrl(filters),
  title: customTitle ?? filters.topic?.treatment ?? filters.topic?.specialist ?? 'Specialty',
});
